import { render, staticRenderFns } from "./modelEvaluation.vue?vue&type=template&id=61e5e20b&scoped=true&"
import script from "./modelEvaluation.vue?vue&type=script&lang=js&"
export * from "./modelEvaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e5e20b",
  null
  
)

export default component.exports